import { Tag, message, Layout, ConfigProvider, Breadcrumb, Spin, Table, DatePicker, Select, AutoComplete, Button, Drawer, Form, Col, Row, Input, Descriptions, Card, Checkbox} from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import esES from 'antd/lib/locale/es_ES';
import React, { useState } from 'react';
import { useEffect } from 'react';
import reqwest from 'reqwest';
import moment from 'moment';
import 'antd/dist/antd.css';
import './index.css';
import MyMenu from '../../components/Menu';
import {getToken} from '../../Utils/common';
import { useHistory } from "react-router-dom";
import config from '../../config'

import './index.css'

const { Content, Sider, Header } = Layout;
const {RangePicker} = DatePicker;
const {Option} = Select;

moment.locale('es');

function Billing (){
    const history = useHistory();
  const [collapsed, setCollapsed] = useState(false);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState('&search=');

  const [appointmentsData, setAppointmentsData] = useState([]);
  const [loadingList, setLoadingList] = useState(false);
  const [profesionals, setProfesionals] = useState([]);
  const [fetchingProfesionals, setFetchingProfesionals] = useState(false);

  const [specialitySelected, setSpecialitySelected] = useState(false);

  const [profesionalSelected, setProfesionalSelected] = useState([])
  const [dateSelected, setDateSelected] = useState([])

  const [fechaSelected, setFechaSelected] = useState("")
  const [profesionalListed, setProfesionalListed] = useState(0)

  const [visibleSearch, setVisibleSearch] = useState(false)

  const [disabled, setDisabled] = useState(true)
  const [visible, setVisible] = useState();
  const [loadingSaveButton, setLoadingSaveButton] = useState(false);
  const [spinning, setSpinning] = useState(false);

  const [appointmentform] = Form.useForm();
  const [formTurno] = Form.useForm(); // TODO: rename

  const [profesionalWorkingHours, setProfesionalWorkingHours] = useState([])
  const [options, setOptions] = useState([]);
  const [autocompleteProfesionalOptions, setAutocompleteProfesionalOptions] = useState([]);

  const [profesionalInfo, setprofesionalInfo] = useState([])
  const [descriptions, setDescriptions] = useState([])

  const [profesionalName, setProfesionalName] = useState('')


  const [autoCompleteText, setAutoCompleteText] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });

  const [medicalInsurances, setMedicalInsurances] = useState([]);

  // Medication billing report state
  const [medReportLoading, setMedReportLoading] = useState(false);
  const [medReportData, setMedReportData] = useState([]);
  const [medReportSummary, setMedReportSummary] = useState(null);
  const [medPacientOptions, setMedPacientOptions] = useState([]);
  const [medPacientText, setMedPacientText] = useState('');
  const [medGroupByMedication, setMedGroupByMedication] = useState(false);
  const [medFilters, setMedFilters] = useState({
    start: moment(),
    end: moment(),
    pacient: null,
    medical_insurance: null,
  });


  useEffect( () => {
      fetchMedicalInsurances("")
  }, []);

   const fetchMedicalInsurances = (params = {}, props) => {
    if (params)
      params=`&search=${params}`

    reqwest({
      url: `${config.api_url}/medicalinsurance/?limit=1000${params}`,
      method: 'get',
      type: 'json',
      headers:{
        'Authorization': `Token ${ getToken() }`,
      }
    })
    .then(data => {
      const medicalinsurances_data = data.results.map(user => ({
        text: `${user.short_name}`,
        value: user.id,
      }));

      setMedicalInsurances(medicalinsurances_data);

    }).catch( (errorInfo) => {
        setLoading(false);
                if( errorInfo.status == 401) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          history.push('/login');
        } else
        message.error(`Ha ocurrido un error al intentar obtener los profesionales.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
    } );
  };

   const onChangeProfesional = (value) => {
    console.log(value)
    if (!value) {
      // setDisabled(true)
      formTurno.setFieldsValue({pacient: ''})
      formTurno.setFieldsValue({pacient_search: ''})
    }
  }


    const handleProfesionalSearch = (value) => {
    fetchProfesionals(value)
  }

  const onCollapse = collapsed => {
    console.log(collapsed);
    setCollapsed( (prevCollapsed) => { return !prevCollapsed } );
  };

  const fetchProfesionals = (params = {}) => {
    setFetchingProfesionals(true);
    setProfesionals([]);

    let search = "";
    if (params)
      search=`?search=${params}`

    if (search === "")
        search = "?limit=100&offset=100"

    reqwest({
      url: `${config.api_url}/profesionals/${search}`,
      method: 'get',
      type: 'json',
      headers:{
        'Authorization': `Token ${ getToken() }`,
      }
    })
    .then(data => {

      console.log("PARAMS IN FETCH");
      console.log(params);
      console.log(data);

      let ops = data.results.map( (values) => {
        console.log("Values del search");
        console.log(values);
        return {
          value: values.id,
          label: `${values.name} ${values.last_name} (${values.id})`
        }
      })
      setAutocompleteProfesionalOptions(ops);
    }).catch( (errorInfo) => {
        setLoading(false);
         if( errorInfo.status == 401) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          history.push('/login');
        } else
        message.error(`Ha ocurrido un error al intentar obtener los profesionales.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
    } );
  };

  const fetch = (params = {}) => {
    setLoadingList(true);

    let medical_insurance = ''
    if (params.filters.medical_insurance){
        medical_insurance = `&medical_insurance=${params.filters.medical_insurance}`
    }
    const filter_query = `&speciality=${params.filters.speciality || ""}&profesional=${params.filters.professional || ""}&start_date=${moment(params.filters.appointment_start).format('YYYY-MM-DD 00:00')}&end_date=${moment(params.filters.appointment_end).format('YYYY-MM-DD 23:59')}&medical_insurance=${params.filters.medical_insurance || ""}&copago=${params.filters.copago || ""}&payment_method=${params.filters.payment_method || ""}`;

    console.log(filter_query)

    reqwest({
      url: `${config.api_url}/billing?${filter_query}`,
      method: 'get',
      type: 'json',
      headers:{
        'Authorization': `Token ${ getToken() }`,
      }
    }).then(data => {
      setLoadingList(false);
      let _descriptions = []
      console.log(data)
      for (const result in data.results){
        console.log(data.results[result]['name'])

        //let total = 0
        let unit = "hora"
        // const total = ((data.results[result]['attended'] / 2) * data.results[result]['appointment_price']) + ((data.results[result]['recipes_attended'] / 4) * data.results[result]['over_shift_price'])
        const total = (data.results[result]['attended'] * data.results[result]['appointment_price']) + (data.results[result]['recipes_attended'] * (data.results[result]['appointment_price']/2))
        const complete_name = `Profesional: ${data.results[result]['name']} ${data.results[result]['last_name']}`

        const appointments = <Descriptions title="Turnos" column={10}>
                                            <Descriptions.Item label="Fecha"></Descriptions.Item>
                                            <Descriptions.Item label="Mod."></Descriptions.Item>
                                            <Descriptions.Item label="Paciente"></Descriptions.Item>
                                            <Descriptions.Item label="Obra Social"></Descriptions.Item>
                                            <Descriptions.Item label="Copago"></Descriptions.Item>
                                            <Descriptions.Item label="Met.Pago"></Descriptions.Item>
                                            <Descriptions.Item label="Debe"></Descriptions.Item>
                                            <Descriptions.Item label="Motivo"></Descriptions.Item>
                                            <Descriptions.Item label="Asistió"></Descriptions.Item>
                                            <Descriptions.Item label="Atendido"></Descriptions.Item>
                                            {data.results[result]['appointment_set'].map((value, index) => {
                                                const appointment_at = moment(value.appointment_at).format("DD-MM-YYYY HH:mm")
                                                let present = '-'
                                                if (value.present == 'P'){
                                                    present = 'Si'
                                                }
                                                else if (value.present == 'A'){
                                                    present = 'No'
                                                }
                                                else if (value.present == 'AA'){
                                                    present = 'No c/aviso'
                                                }

                                                let attended = '-'
                                                if (value.attended == 'Y'){
                                                    attended = 'Si'
                                                }
                                                else if (value.attended == 'N'){
                                                    attended = 'No'
                                                }

                                                let copago = 'No'
                                                if (value.pacient_copago === 'Y'){
                                                    copago = 'Si'
                                                }

                                                return   <>
                                                            <Descriptions.Item label="">{appointment_at}</Descriptions.Item>
                                                            <Descriptions.Item label="">{value.modality}</Descriptions.Item>
                                                            <Descriptions.Item label="">{value.pacient_name} {value.pacient_last_name}</Descriptions.Item>
                                                            <Descriptions.Item label="">{value.pacient_medical_insurance__name}</Descriptions.Item>
                                                            <Descriptions.Item label="">{ copago }</Descriptions.Item>
                                                            <Descriptions.Item label="">{ value.payment_method }</Descriptions.Item>
                                                            <Descriptions.Item label="">{ value.debt_amount }</Descriptions.Item>
                                                            <Descriptions.Item label="">{value.motive}</Descriptions.Item>
                                                            <Descriptions.Item label="">{ present }</Descriptions.Item>
                                                            <Descriptions.Item label="">{ attended }</Descriptions.Item>
                                                         </>
                                            })}
                             </Descriptions>

        const item =  <div>
                      <br/>
                      <Card title={complete_name} >
                              <Descriptions title="A pagar" column={4}>
                                  <Descriptions.Item label="Costo por Paciente">$ {data.results[result]['appointment_price']}</Descriptions.Item>
                                  <Descriptions.Item label="Total">$ {total}</Descriptions.Item>
                                  <Descriptions.Item label="Consultas Atendidas:">{data.results[result]['attended']}</Descriptions.Item>
                                  <Descriptions.Item label="Recetas realizadas">{data.results[result]['recipes_attended']}</Descriptions.Item>
                            </Descriptions>
                            <Descriptions title="No atendidos/completados" column={2}>
                                  <Descriptions.Item label="Consultas no Atendidas">{data.results[result]['not_attended']}</Descriptions.Item>
                                  <Descriptions.Item label="Recetas no realizadas">{data.results[result]['recipes_not_attended']}</Descriptions.Item>
                                  <Descriptions.Item label="Consultas no Completados">{data.results[result]['not_completed']}</Descriptions.Item>
                                  <Descriptions.Item label="Recetas no Completados">{data.results[result]['recipes_not_completed']}</Descriptions.Item>
                                  <Descriptions.Item >{}</Descriptions.Item>
                            </Descriptions>
                           {appointments}
                        </Card>
        </div>

        _descriptions.push(item)
      }
      setDescriptions(_descriptions);
      console.log(descriptions)
    }).catch( (errorInfo) => {
        setLoadingList(false);
         if( errorInfo.status == 401) {
          sessionStorage.removeItem('token');
          sessionStorage.removeItem('user');
          history.push('/login');
        } else
          message.error(`Ha ocurrido un error al intentar obtener la facturacion.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
    } );
  };

  const handleOnChangeSpeciality = value => {
    console.log("Selected speciality");
    console.log(value);

    if (value){
      setSpecialitySelected(value);
      // if (dateSelected)
      //   setDisabled(false)
    }
    else{
      // setDisabled(true)
      setSpecialitySelected(value);

    }
  }

  const onSearchAppointment = (value) => {

    let search_filters = appointmentform.getFieldsValue();

    let filters = {}


      if (!search_filters.appointment_range){
          alert("Debe seleccionar un rango de fechas")
          return
      }

    setFechaSelected(moment(search_filters.appointment_range[0]).format("YYYY-MM-DD"))

    console.log(search_filters)


    filters['appointment_start'] = search_filters.appointment_range[0];



    filters['appointment_end'] = moment(search_filters.appointment_range[1]).format('YYYY-MM-DD 23:59');
    filters['speciality'] = search_filters.speciality
    filters['professional'] = search_filters.profesionalId
    filters['medical_insurance'] = search_filters.medical_insurance
    filters['copago'] = search_filters.copago
    filters['payment_method'] = search_filters.payment_method



    fetch({
      pagination,
      'filters': filters,
    });
  }

  const onDateChange = (value) => {
    console.log("date changed");
    console.log(value);

    if (value){
      // console.log(specialitySelected);
      // if (specialitySelected)
        setDisabled(false)
        setDateSelected(true)
    }
    else{
      setDisabled(true)
      setDateSelected(false)
    }
  }

    const onPrintBilling = () => {
    window.print()
  }

    const onSelectProfesional = (value, option) => {
    setProfesionalName(option.label)
    appointmentform.setFieldsValue({profesional: value})
    appointmentform.setFieldsValue({profesionalId: value})
    appointmentform.setFieldsValue({profesional_search: option.label})
    if (value) {
      if (dateSelected) {
        setDisabled(false)
      }
    }
  }

  return (
    <>
      <ConfigProvider locale={esES}>
        <Layout style={{ minHeight: '100vh'}}>
          <Sider collapsible collapsed={collapsed} onCollapse={onCollapse} className="no-print">
            <div className="logo" />
            <MyMenu active={active} />
          </Sider>
          <Layout className="site-layout">
            <Header />
            <Content style={{ margin: '0 16px' }}>
                <Breadcrumb style={{ position: "relative", margin: '16px 0' }} className="no-print">
                  <Breadcrumb.Item>Home</Breadcrumb.Item>
                  <Breadcrumb.Item>Facturación</Breadcrumb.Item>
                  <Breadcrumb.Item>Reporte por Profesional</Breadcrumb.Item>
                </Breadcrumb>

                <Card title="Reporte por Profesional">
                  <Form
                    form={appointmentform}
                    layout="vertical"
                    hideRequiredMark
                    className="no-print" // Ocultar filtros en impresión
                  >
                    <Row gutter={8}>
                      <Form.Item name="profesionalId" label="profesionalId" hidden>
                        <Input hidden/>
                      </Form.Item>

                      <Col span={8}>
                        <Form.Item name="appointment_range" label="Rango de fechas">
                          <RangePicker format={"DD/MM/YYYY"} onChange={onDateChange} />
                        </Form.Item>
                      </Col>

                      <Col span={8}>
                        <Form.Item name="profesional_search" label="Profesional">
                          <AutoComplete
                            style={{ width: '100%' }}
                            dropdownMatchSelectWidth={252}
                            options={autocompleteProfesionalOptions}
                            onSelect={onSelectProfesional}
                            onChange={onChangeProfesional}
                            onSearch={handleProfesionalSearch}
                          >
                            <Input placeholder="Seleccione un profesional" value={autoCompleteText} />
                          </AutoComplete>
                        </Form.Item>
                      </Col>

                      <Col span={6}>
                        <Form.Item name="medical_insurance" label="Obra Social">
                          <Select
                            style={{ width: '100%' }}
                            placeholder="Seleccione obra social"
                            showSearch
                            allowClear
                            showArrow={false}
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            onChange={() => { /* keep behavior */ }}
                          >
                            {medicalInsurances.map(d => (
                              <Option key={d.value} value={d.value}>{d.text}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col span={4}>
                        <Form.Item name="speciality" label="Especialidad">
                          <Select
                            style={{ width: '100%' }}
                            allowClear
                            onSelect={handleOnChangeSpeciality}
                            placeholder="Seleccione una especialidad"
                          >
                            <Option value="PS">Psicología</Option>
                            <Option value="PQ">Psiquiatría</Option>
                            <Option value="EN">Enfermería</Option>
                            <Option value="TE">Terapista</Option>
                            <Option value="ME">Médico</Option>
                            <Option value="MG">Médico de Guardia</Option>
                            <Option value="KI">Kinesiología</Option>
                            <Option value="TO">Terapia Ocupacional</Option>
                            <Option value="MU">Musicoterapia</Option>
                            <Option value="NU">Nutrición</Option>
                            <Option value="TS">Trabajo Social</Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col span={3}>
                        <Form.Item name="copago" label="Copago">
                          <Select style={{ width: '100%' }} allowClear placeholder="Seleccione">
                            <Option value="N">No</Option>
                            <Option value="Y">Sí</Option>
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col span={5}>
                        <Form.Item name="payment_method" label="Método de Pago">
                          <Select style={{ width: '100%' }} allowClear placeholder="Seleccione">
                            <Option value="NA">-</Option>
                            <Option value="FT">Efectivo</Option>
                            <Option value="MP">Mercado Pago</Option>
                            <Option value="TR">Transferencia</Option>
                            <Option value="OT">Otro</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                  <div style={{ textAlign: 'right' }} className="no-print">{/* Ocultar botones en impresión */}
                    <Button onClick={onSearchAppointment} type="primary" loading={loadingList} disabled={disabled}>Generar reporte</Button>
                    <Button onClick={onPrintBilling} icon={<PrinterOutlined />} style={{ marginLeft: 8 }} disabled={disabled}>Imprimir</Button>
                  </div>

                  <div style={{ marginTop: 16 }}>
                    <Spin spinning={loadingList} tip="Generando reporte...">
                      <div>{ descriptions }</div>
                    </Spin>
                  </div>
                </Card>

                {/* Reporte de Medicación eliminado de la vista clásica. Usar la página específica /billing/medications/ */}
            </Content>
          </Layout>
        </Layout>
      </ConfigProvider>
    </>
  );
}
export default Billing;
